import { getDynamicReportColumns } from "./getDynamicReportColumns";
import {getParsedColumns} from "./getParsedColumns";
import { Columns } from './Columns';

export const ColumnsHelper = {
    getAllColumns(storageKey, props = {}, fields = []) {
        return getParsedColumns(storageKey, props, fields);
    },
    getDefaultColumns(storageKey, props, fields) {
        return getParsedColumns(storageKey, props, fields)
            .filter(column => column.required || column.defaulto)
            .map(column => ({
                key: column.key,
                width: null,
            }));
    },
    getDynamicReportColumns(storageKey, storageData, props, fields) {
        return getDynamicReportColumns(storageKey, storageData, props, fields);
    },

    getInitialReportLabel(storageKey, title = '') {
        if (!storageKey)
            return title;

        const reportLabel = Columns[storageKey]?.getReportLabel() || title;
        return reportLabel;
    },
    extractColumnKeys(storageData) {
        const storageColumns = storageData?.columns || [];
        return storageColumns.map(column => column.key);
    },
    filterColumns(columns = [], storageData = {}, extraFilterFn = () => false) {
        const storageColumns = storageData?.columns || [];
        return columns.filter(column => (
            storageColumns.find(c => c.key === column.key) ||
            extraFilterFn(column)
        ));
    },
    filterResizableColumns(columns = [], storageData = [], onResize = () => {}) {
        const storageColumns = storageData?.columns || [];

        return columns
            .map(column => {
                const storageColumn = storageColumns.find(c => c.key === column.key);

                if (storageColumn) {
                    return {
                        ...column,
                        minWidth: column.width,
                        width: storageColumn?.width || column.width,
                        isResizable: true,
                        onHeaderCell: column => ({
                            ...column,
                            width: column.width || 80,
                            minWidth: column.minWidth || 80,
                            onResize: onResize(column.key),
                        }),
                    };
                }
                return { to_remove: true };
            })
            .filter(column => !column.to_remove);
    },
};
